export default function Hero() {
  const handleScrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-20 -right-20 w-[500px] h-[500px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute -bottom-32 -left-32 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                每日更新
              </span>
              <span className="px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap">
                全本免费
              </span>
              <span className="px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                高清画质
              </span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 font-heading leading-tight text-balance">
              蛙漫漫画
              <span className="block text-2xl md:text-3xl lg:text-4xl text-primary-600 mt-2">
                韩漫日漫国漫免费在线阅读平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-500 mt-3 font-heading">
              海量漫画，一网打尽
            </p>

            <p className="text-sm md:text-base text-foreground-600 mt-6 leading-relaxed max-w-[560px] mx-auto lg:mx-0 text-balance">
              蛙漫漫画致力于为广大漫画爱好者提供最全、最新、最优质的漫画阅读体验。
              平台涵盖韩漫、日漫、国漫三大品类，每日持续更新热门连载与新作上线，
              所有漫画均可免费在线阅读，无需注册即可畅享精彩内容。
              无论你是韩漫迷、日漫控还是国漫粉，这里都有属于你的漫画世界。
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-6 md:gap-10 mt-7 flex-wrap">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">10万+</div>
                <div className="text-xs text-foreground-500 mt-1">漫画资源</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">每日50+</div>
                <div className="text-xs text-foreground-500 mt-1">持续更新</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-600 font-heading">100%</div>
                <div className="text-xs text-foreground-500 mt-1">免费阅读</div>
              </div>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-3 mt-8 flex-wrap">
              <a
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  handleScrollTo('#carousel');
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                开始阅读
              </a>
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  handleScrollTo('#app');
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-100 text-foreground-800 text-sm font-semibold hover:bg-background-200 transition-colors border border-background-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[300px] h-[380px] md:w-[380px] md:h-[480px] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20manga%20and%20comic%20book%20illustration%20with%20floating%20panels%20and%20dynamic%20characters%2C%20Japanese%20Korean%20Chinese%20comic%20art%20style%20fusion%2C%20warm%20orange%20and%20coral%20tones%2C%20speech%20bubbles%2C%20ink%20splashes%2C%20energetic%20reading%20atmosphere%2C%20artistic%20composition%20with%20rich%20textures%20and%20creative%20layout%2C%20editorial%20quality%20with%20soft%20warm%20background&width=760&height=960&seq=hero-manga-visual&orientation=portrait"
                alt="蛙漫漫画 - 韩漫日漫国漫精彩阅读体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}